<template>
  <ExcursionFilterPopupWrapper
    :title="title"
    :items-count="itemsCount"
    :static-title="t('movement.title')"
    filter-key="movementTypes"
    :is-active="isActive"
    :is-disabled-reset-button="isDisabledResetButton"
    :is-scroll="isScroll"
    :is-modal-only="isFullscreen"
    @apply="handleApply"
  >
    <ExcursionMovementTypesList
      :aggregation-movement-type="props.aggregationMovementType"
      :movement-types="movementTypes"
      @update:selectedTypes="updateMovementTypes"
    />
  </ExcursionFilterPopupWrapper>
</template>

<script setup lang="ts">
  // TODO: Заменить на нужный компонент вертикали
  import { ExcursionFilterPopupWrapper } from '@/entities/filter/popup-wrapper';
  // TODO: Заменить на нужный компонент вертикали
  import { ExcursionMovementTypesList, useMovementTypes, type TMovementTypeGroup } from '@/entities/movement-type';
  import { useExcursionFiltersStore, type TExcursionFiltersState } from '@/entities/filter/store/excursion';
  import type { TMovementType } from '@/entities/movement-type';
  import { useExcursionFilterMovementTitle } from '../../composables/excursion/useExcursionFilterMovementTitle';
  import type { IExperienceAggregations } from '@/entities/experience/aggregation';
  import { locales } from '../../i18n';
  import { useComponentI18n } from '@/shared/composables/useComponentI18n';

  interface Props {
    aggregationMovementType: IExperienceAggregations['movementType'];
    isScroll: boolean;
    isFullscreen: boolean;
  }

  interface Emits {
    (e: 'apply', isForced: boolean, filterData?: Partial<TExcursionFiltersState>): void;
  }

  const props = defineProps<Props>();
  const emit = defineEmits<Emits>();

  const { t } = useComponentI18n(locales);

  const movementTypes = useMovementTypes();
  const filtersStore = useExcursionFiltersStore();

  const { title, itemsCount, isActive } = useExcursionFilterMovementTitle(locales.ru);

  const updateMovementTypes = (selectedTypes: Array<TMovementType | TMovementTypeGroup>) => {
    filtersStore.state.movementTypes = selectedTypes;
  };

  const isDisabledResetButton = computed(() => {
    return !filtersStore.state.movementTypes;
  });

  const handleApply = (isForced: boolean) => {
    const filterData: Partial<TExcursionFiltersState> = {
      movementTypes: filtersStore.searchState.movementTypes,
    };
    emit('apply', isForced, filterData);
  };
</script>

<style scoped lang="scss">
  :deep(.popup__content) {
    padding-right: 16px !important;
    padding-left: 16px !important;
  }
</style>
